<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="选择类型" prop="endDate">
            <el-select v-model="queryParams.type" placeholder="请选择">
              <el-option
                v-for="item in selectData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="数据类型" prop="endDate">
            <el-select v-model="queryParams.dataType" placeholder="请选择">
              <el-option
                v-for="item in dataTypeData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>用户皮肤统计</span>
        </div>

        <el-table
          :data="tableData"
          border
        >
          <el-table-column
            prop="title"
            label="皮肤"
            align="center"
          />

          <el-table-column
            label="拥有人数"
            align="center"
          >
            <template v-slot:default="scope">
              {{ tableData[scope.$index].user }}
            </template>
          </el-table-column>
          <el-table-column
            label="占比"
            align="center"
          >
            <template v-slot:default="scope">
              {{ tableData[scope.$index].rate }}%
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <!--      <el-row :gutter="12">-->
      <!--        <userStat ref="userStat" :title="'人数'" />-->
      <!--      </el-row>-->

      <el-row :gutter="12">
        <userStat ref="userStatRate" :title="'占比'" :k="'rate'" />
      </el-row>

    </template>
  </BasicLayout>
</template>

<script>
import userStat from '@/views/config/user-skin-num/components/user-stat.vue'
import { getCacheConfig, getCacheQuery, getLastDates, scientificFormat, setCacheQuery } from '@/utils'
import { getUserSkinDataStat } from '@/api/statistics/user_remain'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
export default {
  name: 'UserSkinStat',
  components: {
    userStat
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        type: 1,
        dataType: 1
      },
      rangeTitle: [],
      selectData: [
        { label: '野兽', value: 1 },
        { label: '棋子', value: 2 },
        { label: '盾牌', value: 3 }
      ],
      dataTypeData: [
        { label: '活跃', value: 1 },
        { label: '历史', value: 2 }
      ],
      tableData: [],
      data: {},
      diceSkinConfig: [],
      shieldSkinConfig: [],
      beastSkinConfig: []
    }
  },
  created() {
    this.getSkinConfig()
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(1)
    }

    // if (!this.queryParams.endDate) {
    //   this.queryParams.endDate = getLastDates(1)
    // }

    this.getTables(undefined)
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getSkinConfig() {
      getCacheConfig(getAnimalAllList, 'getAnimalAllList').then(res => { this.setConfig(this.beastSkinConfig, res.data) })
      getCacheConfig(getShieldsAllList, 'getShieldsAllList').then(res => { this.setConfig(this.shieldSkinConfig, res.data) })
      getCacheConfig(getSieveAllList, 'getDiceAllList').then(res => { this.setConfig(this.diceSkinConfig, res.data) })
    },
    setConfig(conf, data) {
      conf.push({ label: '无', value: 0 })
      for (const i in data) {
        conf.push({ label: data[i].lang_key, value: parseInt(data[i].id) })
      }
    },
    getTables(event) {
      this.loading = true
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getUserSkinDataStat(this.queryParams).then(res => {
        this.loading = false
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          this.tableData = []
          if (res.data.length <= 0) {
            return
          }
          let tableData = res.data.data.data
          if (this.queryParams.dataType === 2) {
            tableData = res.data.data.history
          }
          const rangeTitle = []
          const skinData = []
          for (const i in tableData) {
            const td = tableData[i]
            skinData.push(td.skin)
          }

          let skinConfig = []
          switch (this.queryParams.type) {
            case 1:
              skinConfig = this.beastSkinConfig
              break
            case 2:
              skinConfig = this.diceSkinConfig
              break
            case 3:
              skinConfig = this.shieldSkinConfig
              break
          }

          skinConfig.forEach(item => {
            if (skinData.includes(item.value)) {
              rangeTitle[item.value] = item.label
            }
          })
          for (const i in tableData) {
            const val = tableData[i]
            let title = '未知'
            if (rangeTitle[val.skin]) {
              title = rangeTitle[val.skin]
            }
            this.tableData.push({
              title: title,
              user: val.count,
              rate: val.user_rate
            })
          }
          // this.$refs.userStat.refresh(res.data.data, this.rangeTitle)
          this.$refs.userStatRate.refresh(this.tableData, rangeTitle)
          // this.tableData = res.data.data
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
